// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZL_7n","content":"styles_content__dsL-U"};